import { render, staticRenderFns } from "./vip-fixed-header.vue?vue&type=template&id=07386f62&scoped=true&"
import script from "./vip-fixed-header.vue?vue&type=script&lang=js&"
export * from "./vip-fixed-header.vue?vue&type=script&lang=js&"
import style0 from "./vip-fixed-header.vue?vue&type=style&index=0&id=07386f62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07386f62",
  null
  
)

export default component.exports